import {
  ComponentBox,
  ComponentBoxHeaderFooter,
  LoadingSpinner,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';

import styles from './AutoLayoutBox.less';
import ScreensWrapper from './ScreensWrapper';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

export const I18N = defineMessages({
  LOADING: {
    id: 'autoLayout.loading',
    defaultMessage: 'Loading...',
    description: 'text for loading spinner in auto layout box',
  },
});

class AutoLayoutBox extends React.PureComponent {
  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      isLoadingCounter,
      loadingDisabled,
      metadata,
      screenId,
      screenStyles,
      showBoxHeader,
      titleText,
      helpText,
    } = this.props;
    const isLoading = !loadingDisabled && isLoadingCounter > 0;
    return (
      <div
        className={styles.dlAutoLayoutBox}
        data-name={'AutoLayoutBoxWrapper'}
      >
        <div
          className={classNames(
            styles.dlAutoLayoutBox,
            'dlLoadingSpinnerContainerOverflowed',
            'dlFlexBoxContainerInContainer',
            {dlLoadingSpinnerParent: isLoading}
          )}
          data-name={'loadingSpinnerParent'}
        >
          <LoadingSpinner isVisible={isLoading} text={I18N.LOADING.id} />
          {showBoxHeader ? (
            <ComponentBoxHeaderFooter
              titleText={titleText}
              helpText={helpText}
            />
          ) : null}
          <ComponentBox hasScrollbar>
            {contextParams && screenId ? (
              <ScreensWrapper
                autoLayoutStateId={autoLayoutStateId}
                config={config}
                configStateId={configStateId}
                contextParams={contextParams}
                metadata={metadata}
                screenId={screenId}
                screenStyles={screenStyles}
              />
            ) : null}
          </ComponentBox>
        </div>
      </div>
    );
  }
}

AutoLayoutBox.displayName = 'AutoLayoutBox';

AutoLayoutBox.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any),
  isLoadingCounter: PropTypes.number.isRequired,
  loadingDisabled: PropTypes.bool,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string,
  helpText: PropTypes.string,
  screenStyles: PropTypes.objectOf(PropTypes.any),
  showBoxHeader: PropTypes.bool,
  titleText: PropTypes.string,
};

AutoLayoutBox.defaultProps = {
  contextParams: undefined,
  helpText: '',
  loadingDisabled: false,
  screenId: undefined,
  screenStyles: undefined,
  showBoxHeader: false,
  titleText: '',
};

export default AutoLayoutBox;
